// useDelayedFlag — `active` が `delayMs` 続いて初めて true になり、false になったら即 false。
// 再接続帯の「ブロックは即時、表示は遅らせる」(一瞬の切断でちらつかせない) 用。

import { useEffect, useState } from 'react';

export const RECONNECT_BAND_DELAY_MS = 1800;

export const useDelayedFlag = (active: boolean, delayMs: number): boolean => {
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!active) {
      setShown(false);
      return;
    }
    const timer = setTimeout(() => setShown(true), delayMs);
    return () => clearTimeout(timer);
  }, [active, delayMs]);
  return active && shown;
};
